import { render, staticRenderFns } from "./DynamicComponent.vue?vue&type=template&id=74a53a51&scoped=true"
import script from "./DynamicComponent.vue?vue&type=script&lang=js"
export * from "./DynamicComponent.vue?vue&type=script&lang=js"
import style0 from "./DynamicComponent.vue?vue&type=style&index=0&id=74a53a51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a53a51",
  null
  
)

export default component.exports